// Libs
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { GetSharedKitMessages } from '../actions/sharedKits';

const useSharedKitMessages = () => {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.sharedKits?.messages);

  useEffect(() => {
    if (!messages) {
      dispatch(GetSharedKitMessages());
    }
  }, [dispatch, messages]);

  return {
    reorderMessage: messages?.reorderMessage || '',
    addToMyKitsMessage: messages?.addToMyKitsMessage || '',
  };
};

export default useSharedKitMessages;
